import React, {useEffect, useState} from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/system';



const Header = styled('h1')(({ theme }) => ({
  fontSize: '1.65rem',
  width: '100%',
  fontWeight: 'normal',
  fontFamily: theme.typography.fontFamily,
  color: '#2E2E2E',
  paddingTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontFamily: theme.typography.infoKey.fontFamily,
  fontWeight: theme.typography.infoKey.fontWeight,
  color: theme.typography.infoKey.color,
  fontSize: '1rem',
}));

const StyledTableRow = styled(TableRow)(({ status, theme }) => ({
    backgroundColor: status === 'in_progress' ? "#E6F3FF" : status === 'failed' ? "#FFE7E6" : "#F1FFE6",
    borderRadius: '10px', // Adding rounded corners
    '&:hover': {
      backgroundColor: status === 'in_progress' ? "#D3E3F1" : status === 'failed' ? "#F4CECB" : "#D6EEC3",
    },
  }));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '1rem',
}));

const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  height: '100%',
});

const ButtonWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  marginLeft: "0",
  marginBottom: theme.spacing(5),
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'center',
}));

const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
});

const ReviewPageHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  alignContent: 'start',
  width: '100%',
});

export { ContentContainer, PageContainer, Header, StyledTableHeader, StyledTableRow, StyledTableCell, ButtonWrapper, ReviewPageHeader };
